export function sortAppsByName(apps) {
    if (Array.isArray(apps) && apps.length > 0) {
        apps.sort((a, b) => a.appName.localeCompare(b.appName));
    }
}
